import * as Yup from "yup"
import {
  yupDateDayMatchMonth,
  yupRequiredEmail,
  yupRequiredNumberBetween,
  yupRequiredPositiveNumber,
  yupRequiredTime
} from "../../yup/Validators"

export const AdminConfigurationSchema = Yup.object().shape({
  dashboardBookingPendingWindow: yupRequiredPositiveNumber,
  dashboardBookingTodoWindow: yupRequiredPositiveNumber,
  dashboardStaffingWindow: yupRequiredPositiveNumber,
  bookingPreBookingDelay: yupRequiredPositiveNumber,
  bookingServiceDelay: yupRequiredPositiveNumber,
  departureTimeMinuteDelta: yupRequiredPositiveNumber,
  staffingAmplitude: yupRequiredTime,
  accountingPeriodStartDay: yupDateDayMatchMonth("accountingPeriodStartDay", "accountingPeriodStartMonth"),
  accountingPeriodStartMonth: yupRequiredNumberBetween(1, 12),
  accountingPeriodEndDay: yupDateDayMatchMonth("accountingPeriodEndDay", "accountingPeriodEndMonth"),
  accountingPeriodEndMonth: yupRequiredNumberBetween(1, 12),
})

export const AdminConfigurationMailSchema = Yup.object().shape({
  mailContact: yupRequiredEmail(3,50),
})
